import styled, {css} from 'styled-components'

export const ScreenReaderOnly = styled.span`
  position: absolute !important;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
`

export const ShowForMediumUp = css`
  display: none;

  @media (min-width: 40em) {
    display: block;
  }
`

export const HideForSmallOnly = css`
  @media (min-width: 73em) {
    display: none;
  }

  @media (min-width: 40em) {
    display: none;
  }
`

export default {
  ScreenReaderOnly,
  ShowForMediumUp,
  HideForSmallOnly,
}
